module.exports = __webpack_public_path__ + "static/media/za.47ca8a2f.png";